export const getValueByDotPath = (root: unknown, path: string): unknown => {
  const trimmed = path.trim()
  if (!trimmed) return undefined

  let current: unknown = root
  for (const segment of trimmed.split('.')) {
    if (current == null) return undefined

    if (Array.isArray(current)) {
      const index = Number(segment)
      if (Number.isNaN(index)) return undefined
      current = current[index]
      continue
    }

    if (typeof current === 'object') {
      current = (current as Record<string, unknown>)[segment]
      continue
    }

    return undefined
  }

  return current
}
